module.exports = __webpack_public_path__ + "static/codfillets-a952cc762fb7ce4f075a756a775bdcb2.jpg";